$(document).on("turbo:load", function () {
  window.Rails.refreshCSRFTokens();
});
